import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  // Использовать когда карточка — кликабельный элемент. Добавляет hover-lift и
  // press-down. Не подменяет роли: используйте на <a>/<button>-родителях.
  interactive?: boolean;
  // Plain — без тени, только бордер. Для вторичной плотной информации.
  plain?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, interactive, plain, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-[18px] border border-stroke bg-white p-5',
        plain ? 'shadow-none' : 'shadow-soft',
        interactive && 'lift-on-hover press-down cursor-pointer',
        className,
      )}
      {...rest}
    />
  );
});
